<template>
  <v-row no-gutters>
    <v-col class="pa-5" cols="12">
      <v-row no-gutters class="align-center">
        <v-col cols="auto">
          <italic-subheader :translation-path="subheader" />
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="mr-5">
          <data-input
            v-model="search"
            :data-type="{ name: 'text' }"
            :placeholder="$i18n.t('default.find')"
            append-icon="mdi-magnify"
            hide-details
          />
        </v-col>
        <v-col cols="auto">
          <v-btn outlined @click="changeListView">
            <v-icon small>{{ icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <keep-alive>
            <component
              :is="getTabName"
              :attachments="searchedItems"
              @input="setSelected"
              :assigned="selected"
              :is-external-attachments="isExternalAttachments"
              :single-select="singleSelect"
            />
          </keep-alive>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import AttachmentTileGrid from '@/components/AttachmentTileGrid';
import AttachmentListView from '@/components/AttachmentListView';
import ItalicSubheader from '@/components/ItalicSubheader';
import DataInput from '@/components/DataInput';

export default {
  name: 'AssignAttachmentTab',
  components: { AttachmentTileGrid, AttachmentListView, ItalicSubheader, DataInput },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    subheader: {
      type: String,
      required: true,
    },
    isExternalAttachments: {
      type: Boolean,
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    search: '',
    gridView: false,
  }),
  computed: {
    icon() {
      if (this.gridView) {
        return 'mdi-view-grid';
      } else {
        return 'mdi-menu';
      }
    },
    searchedItems() {
      if (!this.search) {
        return this.attachments;
      } else {
        return this.attachments.filter(a => a.name.includes(this.search));
      }
    },
    getTabName() {
      if (this.gridView) {
        return 'AttachmentListView';
      } else {
        return 'AttachmentTileGrid';
      }
    },
  },
  methods: {
    changeListView() {
      this.setSelected([]);
      this.gridView = !this.gridView;
    },
    setSelected(data) {
      this.$emit('selectAttachments', data);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input__icon .v-icon {
    font-size: 18px;
  }
  .v-input__control .v-input__slot {
    min-height: 25px !important;
  }
  .v-input__append-inner {
    margin-top: 0 !important;
    align-self: center;
  }
  .v-btn--outlined {
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    padding: 0 !important;
    min-width: 45px !important;
  }
}
</style>
